import React from 'react';
import { DealerChatList } from '../components/DealerChat';
import { useTitle } from '../hooks/useTitle';

const Chats = () => {
  useTitle('Chats');

  return <DealerChatList />;
};

export default Chats; 